import { initiateLoginController } from '../../api/controllers/loginController';
import { loginActionType } from '../../actionTypes';

const DEFAULT_AMOUNT = 15000;
const initiateLogin = (data) => (dispatch) => {
  dispatch({
    type: loginActionType.INITIATE_LOGIN_REQUEST,
    payload: {},
  });
  initiateLoginController(data)
    .then(({ data: respData }) => {
      const {
        isEligible,
        isNtbAllowed,
        isPreapproved: isPreApproved,
        userStatus,
      } = respData;
      dispatch({
        type: loginActionType.INITIATE_LOGIN_SUCCESS,
        payload: {
          mobileNo: data.mobile,
          isEligible,
          isNtbAllowed,
          isPreApproved,
          userStatus,
        },
      });
    })
    .catch(({ data: error }) => {
      const { errorCode, message } = error || {};
      dispatch({
        type: loginActionType.INITIATE_LOGIN_ERROR,
        payload: {
          errorMessage: message,
        },
      });
    });
};

export default initiateLogin;



// WEBPACK FOOTER //
// ./actions/onLogin/initiateLogin.js